//  Copyright 2023
//  Myriota Pty Ltd
//  Myriota Confidential

import * as React from "react";
import { RedocStandalone } from "redoc";
import { REDOC_THEME } from "src/common/constant";

export interface IAccessTimesComponentProps {
    yamlFile: any;
}

export class AccessTimesComponent extends React.Component<IAccessTimesComponentProps, any> {
    render() {
        return (
            <div>
                <RedocStandalone specUrl={this.props.yamlFile}
                    options={{
                        nativeScrollbars: true,
                        theme: REDOC_THEME,
                    }}
                />
            </div>
        )
    }
}

export default AccessTimesComponent;
